/**
 * Chess piece Unicode symbols
 */

/**
 * Unicode chess piece symbols mapped by color and type
 * Uses filled symbols (♚ ♛ ♜ ♝ ♞ ♟) for both colors - differentiated by CSS
 * Variation selector \uFE0E forces text rendering (prevents emoji)
 */
export const PIECE_SYMBOLS: Record<string, Record<string, string>> = {
  WHITE: {
    KING: "\u265A\uFE0E",
    QUEEN: "\u265B\uFE0E",
    ROOK: "\u265C\uFE0E",
    BISHOP: "\u265D\uFE0E",
    KNIGHT: "\u265E\uFE0E",
    PAWN: "\u265F\uFE0E",
  },
  BLACK: {
    KING: "\u265A\uFE0E",
    QUEEN: "\u265B\uFE0E",
    ROOK: "\u265C\uFE0E",
    BISHOP: "\u265D\uFE0E",
    KNIGHT: "\u265E\uFE0E",
    PAWN: "\u265F\uFE0E",
  },
};

/**
 * Gets the Unicode symbol for a chess piece
 *
 * @param color - Piece color (WHITE or BLACK)
 * @param type - Piece type (KING, QUEEN, ROOK, BISHOP, KNIGHT, PAWN)
 * @returns Unicode symbol string
 */
export function getPieceSymbol(color: string, type: string): string {
  return PIECE_SYMBOLS[color]?.[type] ?? "";
}
